import { css } from 'styled-system/css';

export const sportMenuStyle = {
	expandContainer: css({
		_mars: {
			top: '6px',
			left: '6px',
			right: '6px',
			border: 'none',
			_before: {
				content: '""',
				position: 'absolute',
				top: '33px',
				left: '1px',
				right: '1px',
				display: 'block',
				h: '12px',
				zIndex: 2,
				backgroundImage: 'linear-gradient(to top, var(--lv2-0) 0%, {colors.panel.bg} 100%)',
				pointerEvents: 'none',
			},
			_after: {
				position: 'absolute',
				bottom: 0,
				h: '12px',
				backgroundImage: 'linear-gradient(to bottom, var(--lv2-0) 0%, {colors.panel.bg} 100%)',
			}
		},
	}),
	expandWrap: css({
		_mars: {
			layerStyle: 'panel',
			p: 0,
			borderRadius: '6px',
			border: '1px solid {colors.black.5}',
		}
	}),
	sportsMenu_mask: css({
		_mars: {
			w: '12px',
			bgColor: 'sportsMenu.bg',
			backgroundImage: 'none',
			mb: '2px',
		},
	}),
	sportsMenu_maskLeft: css({
		_mars: {
			maskImage: 'linear-gradient(to right, {colors.blackOpacity.100} 0%, {colors.blackOpacity.0} 100%)',
		},
	}),
	sportsMenu_maskRight: css({
		_mars: {
			maskImage: 'linear-gradient(to left, {colors.blackOpacity.100} 0%, {colors.blackOpacity.0} 100%)',
		},
	}),
	moreButton: css({
		_mars: {
			py: '3px',
			'& .icon': {
				mb: 0,
				width: '20px',
				height: '20px',
			}
		},
	}),
	sportsOrder: css({
		_mars: {
			bgColor: 'panel.bg',
			_after: {
				display: 'none',
			}
		},
	}),
	sportsOrder_title: css({
		_mars: {
			px: '12px',
			py: '6px',
			fontSize: '14px',
			fontWeight: 'normal',
			color: 'black.2',
		}
	}),
	closeButton: css({
		base: {
			display: 'none',
		},
		_mars: {
			display: 'block',
			position: 'absolute',
			top: '3px',
			right: '3px',
			'& .icon': {
				mb: 0,
				width: '18px',
				height: '18px',
			},
		},
	}),
	sportsOrder_list: css({
		_mars: {
			display: 'flex',
			justifyContent: 'flex-start',
			flexWrap: 'wrap',
			px: '6px',
			py: '12px',
			maxH: '290px',
			overflow: 'auto',
			gap: '3px',
		}
	}),
	sportsOrder_item: css({
		_mars: {
			flex: '0 0 auto',
			m: 0,
			px: '6px',
			py: '9px',
			flexDirection: 'row',
			width: '32%',
			textAlign: 'left',
			color: 'black.2',
			border: '1px solid {colors.black.5}',
			'&[data-selected="true"]': {
				color: 'sportsMenu.buttonActive',
				borderColor: 'sportsMenu.buttonActive',
			}
		}
	}),
	menuLiveIcon: css({
		_mars: {
			bgColor: 'panel.bg!',
		},
	}),
	sportsOrder_label: css({
		_mars: {
			display: 'block',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			fontSize: '14px',
		},
	})
};